let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3jFnE")).then(() => parcelRequire('F3yzi'));